# A SHIM. The loader itself is ../../widget/agent-widget-loader.js, because the
# marketing site needs the same code and cannot import from this bundle — see
# the comment at the top of that file, and card 6aa8b5f050645cd1c3e765c0. Every
# fix to how the widget mounts, what it posts and whose messages it believes
# belongs THERE, so that the homepage gets it too.
agentWidget = require '../../widget/agent-widget-loader.js'

export clearAgentWidgetSession = -> agentWidget.clearSession()

export default initAgentView = (serverUrl = '') ->
  agentWidget.initAgentView serverUrl
